/* LEGACY external link parity port. See PLAN-6.
   Source: DibApp2020/ClientApp/src/components/content/TopicLoader/
   topic-loader.module.css lines 46-89.

   Deliberate divergence from dibdev: no text-decoration / underline.
   The PLAN-5 .content a rule already sets color/no-underline; this
   module only adds the visually-hidden prefix and the trailing icon. */

.externalLink::before {
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
    content: "external link: ";
}

.externalLink:lang(no)::before,
.externalLink:lang(nb)::before {
    content: "ekstern lenke: ";
}

.externalLink::after {
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 20 20"><path d="M12 2.5h-10.5v16h15.5v-10" stroke="%232b66c7" stroke-width="3" fill="none" /><path d="M20 0h-6l2 2 -5 5 2 2 5 -5 2 2z" fill="%232b66c7" /></svg>');
    background-repeat: no-repeat;
    content: "";
    display: inline-block;
    height: 1.4ex;
    margin-left: 0.3ex;
    vertical-align: baseline;
    width: 1.4ex;
}

.externalLink:hover::after,
.externalLink:focus::after {
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 20 20"><path d="M12 2.5h-10.5v16h15.5v-10" stroke="white" stroke-width="3" fill="none" /><path d="M20 0h-6l2 2 -5 5 2 2 5 -5 2 2z" fill="white" /></svg>');
    background-color: #2b66c7;
    box-shadow: 0 0 0 1px #2b66c7;
}
